import { Component } from '@angular/core';

@Component({
  selector: 'app-job-apply',
  templateUrl: './job-apply.component.html',
  styleUrls: ['./job-apply.component.css']
})
export class JobApplyComponent {
   // Set Topbar Option
   Menuoption = 'job';
  Settingicon = true;
  navClass = "nav-light";
}
